// Push notification & study reminder system

export async function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    try {
      const reg = await navigator.serviceWorker.register("/service-worker.js");
      console.log("Service Worker registered");
      return reg;
    } catch (err) {
      console.log("SW registration failed:", err);
    }
  }
  return null;
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const result = await Notification.requestPermission();
  return result === "granted";
}

export function scheduleReminder(hour = 19, minute = 0) {
  // Save reminder time
  localStorage.setItem("reminderTime", JSON.stringify({ hour, minute }));

  // Use setTimeout to schedule next reminder check
  checkAndNotify();
}

function checkAndNotify() {
  const reminderData = localStorage.getItem("reminderTime");
  if (!reminderData) return;

  const { hour, minute } = JSON.parse(reminderData);
  const now = new Date();
  const target = new Date();
  target.setHours(hour, minute, 0, 0);

  // If target time has passed today, schedule for tomorrow
  if (target <= now) target.setDate(target.getDate() + 1);

  const delay = target.getTime() - now.getTime();

  setTimeout(() => {
    const lastPractice = localStorage.getItem("gamification");
    if (lastPractice) {
      const stats = JSON.parse(lastPractice);
      const today = new Date().toDateString();
      if (stats.lastPracticeDate !== today) {
        // Haven't practiced today — send reminder
        showLocalNotification();
      }
    }
    // Schedule next day
    checkAndNotify();
  }, Math.min(delay, 2147483647)); // Max setTimeout value
}

function showLocalNotification() {
  if (Notification.permission === "granted") {
    const messages = [
      "Don't lose your streak! Practice English today.",
      "Your English lesson is waiting for you!",
      "Just 5 minutes of practice makes a difference!",
      "Keep the momentum going — open SpeakEasy!",
      "Your daily English practice awaits!",
    ];
    const msg = messages[Math.floor(Math.random() * messages.length)];
    new Notification("SpeakEasy", { body: msg, icon: "/favicon.ico", tag: "reminder" });
  }
}

export function cancelReminder() {
  localStorage.removeItem("reminderTime");
}
